import { render, staticRenderFns } from "./FeatsPanel.vue?vue&type=template&id=b1e8e90c&scoped=true"
import script from "./FeatsPanel.vue?vue&type=script&lang=js"
export * from "./FeatsPanel.vue?vue&type=script&lang=js"
import style0 from "./FeatsPanel.vue?vue&type=style&index=0&id=b1e8e90c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e8e90c",
  null
  
)

export default component.exports